import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { surpriseService } from '@/services/surprise';
import { useRoute } from 'vue-router';

export function useSurpriseItemList() {
    const route = useRoute();
    const crudAction = useCrudActions();

    const categoryId = route.params.categoryId;
    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: surpriseService.item.list,
        paramsBuilder: () => ({ ...query, categoryId }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            canFetch: () => categoryId !== undefined && categoryId !== null
        }
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: surpriseService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions, categoryId };
}
